import React, { useEffect, useRef, useState } from 'react';
import { playSound } from '@/utils/sound';
import styles from './style.less';

export const LongTouchAction = ({
  children,
  className = '',
  actions,
}: {
  children: React.ReactNode;
  className: string;
  actions: React.ReactNode;
}) => {
  const [showAction, setShowAction] = useState<boolean | null>(null);
  const timerRef = useRef<number>();

  const onLongPress = () => {
    if (actions) {
      setShowAction(true);
    }
  };

  const start = () => {
    timerRef.current = window.setTimeout(() => {
      onLongPress();
      timerRef.current = undefined; // 避免重复触发
    }, 500);
  };

  const clear = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = undefined;
    }
  };

  useEffect(() => {
    if (showAction !== null) {
      playSound('flip');
    }
  }, [showAction]);

  return (
    <div
      className={`${className} ${styles.wrapper}`}
      onMouseDown={start}
      onMouseUp={() => {
        clear();
      }}
      onMouseLeave={clear}
      onTouchStart={start}
      onTouchEnd={() => {
        clear();
      }}>
      {children}
      {showAction ? (
        <div
          className={styles.mask}
          onClick={() => {
            setShowAction(false);
          }}>
          {actions}
        </div>
      ) : null}
    </div>
  );
};
